


















































































































































import { Component, Prop } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import Membership from "../../store/entities/membership";
import Editor from "@tinymce/tinymce-vue";
import MultiPicture from "../../components/multi-picture.vue";
import RegionSelect from "../../components/region-select.vue";
import TinymceInit from "../../lib/TinymceInit";
import Ajax from "@/lib/ajax";
TinymceInit.height = 300;
@Component({
  components: { Editor, RegionSelect, MultiPicture },
})
export default class EditMembership extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  @Prop({ type: Number, default: false })
  membershipId: number;

  tinymceInit = TinymceInit;
  membership: Membership = new Membership();
  type: boolean = false;
  showOnHome: boolean = false;
  courtList :any= [];

  get extData() {
    return {
      membershipId: this.membership.id,
    };
  }
  async created() {
    let reponse = await Ajax.get("/api/services/app/Court/GetAllCourtNames");
    this.courtList = reponse.data.result;
  }

  save() {
    (this.$refs.membershipForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "membership/update",
          data: {
            membership: this.membership,
            images: this.membership.membershipImages,
          },
        });
        (this.$refs.membershipForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  deleteImg(id){
    if(id>0){
      this.$store.dispatch({
         type:  'membership/deleteImg',
         data:{
          id
         }
      }).then(res=>{
        if(res){
          this.$Message.success({
            content:'删除成功'
          })
        }
      })
    }
  }
  cancel() {
    (this.$refs.membershipForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      console.log(
        this.$store.state.membership.editMembership,
        "editMembership"
      );
      // this.membership= this.$store.state.membership.editMembership
      this.membership = Util.extend(
        true,
        {},
        this.$store.state.membership.editMembership
      );
    }
  }
  validateCourtId(rule, value, callback) {
    if (!value) {
      return callback(new Error("请选择球场"));
    } else {
      callback();
    }
  }
   membershipRule = {
    name: [
      {
        required: true,
        message: "请输入名称",
        trigger: "blur",
      },
    ],
    price: [
      {
        required: true,
        message: "请输入球会牌价",
        trigger: "blur",
        type: "number",
      },
    ],
    transferFee: [
      {
        required: true,
        message: "请输入转让费",
        trigger: "blur",
        // type: "number",
      },
    ],
    monthlyFee: [
      {
        required: true,
        message: "请输入月费",
        trigger: "blur",
        type: "number",
      },
    ],
    flow: [
      {
        required: true,
        message: "请输入使用流程",
        trigger: "blur",
      },
    ],
    position: [
      {
        required: true,
        message: "请输入位置",
        trigger: "blur",
      },
    ],
    description: [
      {
        required: true,
        message: "请输入球会简介",
        trigger: "blur",
      },
    ],
    courtId: [
      { required: true, validator: this.validateCourtId, trigger: "blur" },
    ],
  };
}
